import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MibButtonDirective } from '../../button';
import { MibIconComponent } from '../../icons';
import { SimpleEditDialogData } from '../simple-edit-dialog.models';
import { updateTargetHeight } from '../../../utils/dom.utils';
import { MibDialogInitialFocusDirective, MibFieldDirective } from '../../../directives';

let nextId = 0;

@Component({
  imports: [
    ReactiveFormsModule,
    MibButtonDirective,
    MibIconComponent,
    MibDialogInitialFocusDirective,
    MibFieldDirective,
  ],
  templateUrl: './simple-edit-dialog.component.html',
})
export class MibSimpleEditDialogComponent {
  /** The CDK reference of this dialog, closed with its result. */
  readonly dialogRef = inject<DialogRef<string>>(DialogRef);
  /** The payload handed to `dialog.open()` through its `data` option. */
  readonly data = inject<SimpleEditDialogData>(DIALOG_DATA);
  /** Whether the payload asked for the dark surface. */
  readonly isDark = this.data.darkMode === true;
  private readonly uid = nextId++;
  protected readonly titleId = `mib-simple-edit-dialog-title-${this.uid}`;
  protected readonly fieldId = `mib-simple-edit-dialog-field-${this.uid}`;
  protected readonly errorId = `mib-simple-edit-dialog-error-${this.uid}`;

  /** The `maxlength` of the field: one past the limit, so the error shows instead of the typing stopping. */
  readonly TITLE_MAX_LENGTH: number = typeof this.data.maxLength === 'number' ? this.data.maxLength + 1 : 201;
  /** The form holding the edited value. */
  readonly editionForm = new FormGroup({
    title: new FormControl(this.data.currentValue, {
      nonNullable: true,
      validators: [Validators.required, Validators.maxLength(this.TITLE_MAX_LENGTH - 1)],
    }),
  });

  /** The control of the edited value. */
  get titleControl(): FormControl {
    return this.editionForm.controls.title;
  }

  /** Closes the dialog with the trimmed value, when the form is valid. */
  submitForm(): void {
    if (this.editionForm.valid) {
      const rawData = this.editionForm.getRawValue();
      this.dialogRef.close(rawData.title.trim());
    }
  }

  /** Grows the textarea with its content, up to about four lines. */
  updatePromptHeight(event: Event): void {
    updateTargetHeight(event, 180);
  }
}
